export enum EnumEnvironment {
	LOCAL = 'local',
	DEV = 'dev',
	HML = 'stg'
}
